import objectFitImages from "object-fit-images";

if(navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
	objectFitImages();
}
